import { collection, onSnapshot } from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../config/firebase"

export default function useServices() {

    const [services, setServices] = useState([])
    const [loadingServices, setLoadingServices] = useState(true)

    useEffect(() => {

        return onSnapshot(collection(db, 'services'), {
            next: res => {
                setServices(res.docs.map(l => ({ ...l.data(), id: l.id })).filter(itm => itm.title))
                setLoadingServices(false)
            }
        })

    }, [])

    return {
        loadingServices,
        services
    }
}